/* BIOMPLEX · Etikett-Streifen im Shop · live seit 24.10.2026 (vorher Testmodus ?streifen=1)
   Kollektionskopf: Streifen an der rechten Kante des weißen Textfelds.
   Wissenswelt-Artikel: Lese-Streifen, wächst mit dem Lesen, Zeichen erscheint am Ende.
   Knöpfe und „Passt dazu“ laufen nur über CSS (assets/bx-k4.css). */
(function () {
  if (window.__bxStreifen) return; window.__bxStreifen = true;
  var h = document.documentElement;
  // Farb-Vorschau (25.10.2026): ?farbe=gruen | gruen-ohne | aus — gilt bis zum Schließen des Tabs, nur für den eigenen Browser
  try {
    var fp = new URLSearchParams(location.search).get('farbe');
    if (fp) { if (fp === 'aus') sessionStorage.removeItem('bxFarbe'); else sessionStorage.setItem('bxFarbe', fp); }
    ['fuss','kopf'].forEach(function (n) { var v = new URLSearchParams(location.search).get(n); var key = 'bx_' + n; if (v) { if (v === 'aus') sessionStorage.removeItem(key); else sessionStorage.setItem(key, v); } var s = sessionStorage.getItem(key); if (s) h.setAttribute('data-bx-' + n, s); else h.removeAttribute('data-bx-' + n); });
    var fv = sessionStorage.getItem('bxFarbe');
    if (fv) h.setAttribute('data-bx-farbe', fv);
    if (fv && fv.indexOf('welt') === 0 && !document.querySelector('link[href*="bx-farbwelt"]')) {
      var cs = document.currentScript && document.currentScript.src;
      if (cs) { var ln = document.createElement('link'); ln.rel = 'stylesheet'; ln.href = cs.replace('bx-streifen.js', 'bx-farbwelten-vorschau.css') + '&t=' + Date.now(); document.head.appendChild(ln); }
    }
  } catch (e) {}
  h.setAttribute('data-bx-zeichen', 'b');
  h.setAttribute('data-bx-passt', 'kacheln');
  var BER = window.BX_BEREICH || 'neutral', TPL = window.BX_TEMPLATE || '';
  if (BER !== 'neutral') h.setAttribute('data-bx-bereich', BER);

  function streifen(art, ber) {
    var d = document.createElement('div');
    d.className = 'bx-str bx-str--' + art;
    d.setAttribute('aria-hidden', 'true');
    d.setAttribute('data-bx-bereich', ber || 'neutral');
    d.innerHTML = '<span class="bx-str__z">b</span>';
    return d;
  }
  function schrift() {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Figtree:wght@800&display=swap';
    document.head.appendChild(l);
  }

  function start() {
    if (TPL === 'collection') {
      var box = document.querySelector('.section-main-collection-banner .banner__box');
      if (box && !box.querySelector('.bx-str')) {
        schrift();
        box.classList.add('bx-str-traeger', 'bx-kopf-etikett');
        box.appendChild(streifen('kopf', BER));
      }
    }
    if (TPL === 'article') {
      schrift();
      var s = streifen('lesen', BER);
      document.body.appendChild(s);
      var tick = false;
      function stand() {
        tick = false;
        var max = document.documentElement.scrollHeight - innerHeight;
        var p = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 1;
        s.style.setProperty('--p', p.toFixed(3));
        s.classList.toggle('ist-voll', p > 0.97);
      }
      addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(stand); } }, { passive: true });
      stand();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
